// extracted by mini-css-extract-plugin
export default {"packagePricing":"_7m2uwvAbyPbgOxRpiBhHXt"};